import { render, staticRenderFns } from "./InfoWrapper.vue?vue&type=template&id=4e06e22c&scoped=true&"
import script from "./InfoWrapper.vue?vue&type=script&lang=js&"
export * from "./InfoWrapper.vue?vue&type=script&lang=js&"
import style0 from "./InfoWrapper.vue?vue&type=style&index=0&id=4e06e22c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e06e22c",
  null
  
)

export default component.exports